import React, {useState} from "react";
import IconButton from '@mui/material/IconButton';
import CustomDialog from "../../../../../../../components/Dialog/DiaComp";
import TrafficlightButtonGreen from "../../../../../../../components/Button/TrafficlightButtonGreen";
import { TextSignalT1 } from "./TextSignalT1";

export default function Dt1_Signal() {

const [open, setOpen] = useState(false);
const handleOpen = () => {setOpen(true);};
const handleClose = () => {setOpen(false);};

return(
<>      
  
<IconButton onClick={handleOpen}>
    <TrafficlightButtonGreen  />
</IconButton>

<CustomDialog open={open} onClose={handleClose}

    title='Diabetes Type 1 Variants - Analysis'

    content={ <TextSignalT1 />}

/>

</>
)}